const banner = {
  "banner_01_title": "睛漾水凝<span>®</span><br /><em>經典/璀璨系列</em>",
  "banner_02_title": "睛漾水凝<span>®</span><br /><em>花眸/甜漾系列</em>",
  "banner_01_content": "閃耀天生魅力的自然大地色",
  "banner_02_content": "綻放剔透光彩的的自然混血感",
  "banner_button_01": "線上試戴",
  "banner_button_02": "了解睛漾水凝® ",
}

export default banner
